import { useEffect } from "react";
// import { clearDB, fetchTokenFromDb } from "../../services/keycloackconfig.util";
import Loader from "../loader";
import { useParams } from "react-router-dom";
import LocalDb from "../authv2/indexedDB";
import { useLocation, useNavigate } from "react-router-dom";
import { handleClient } from "./authv2";
import { tryKeyCloakLoginOptions } from "../../services/interfaces";
import { tryKeyCloakRefresh } from "../../services/api";

const AutoConnect = () => {
  const { rtoken, path, email, tenant } = useParams<any>();
  const navigate = useNavigate();

  const resetConnect = async () => {
    const res: boolean = await handleClient(email as string);
    if (res) {
      console.log("tokenINffoooo");
      const payload: tryKeyCloakLoginOptions = {
        refresh_token: rtoken,
        grant_type: "refresh_token",
        sname: "vaspiantelco",
        realm: "vaspiantelco",
      };

      const login: any = await tryKeyCloakRefresh(payload);
      // debugger
      if (login.status === 200) {
        const token_data = {
          token_info: login.data,
          logged_time: Date.now(),
          username: email,
          tenant: tenant,
        };
        const tokenStore = LocalDb.loadLocalDB("token", "TokenList", 2);
        LocalDb.set(tokenStore, "TokenList", "dataCookie", {
          value: token_data,
          title: "TokenData",
        });
        console.log("SUCCESS");
        navigate(`/app`, { replace: true });
        // Authv2.token = login.data
        // Authv2.isAuthenticated = activityState.SUCCESS;
      } else {
        console.log("FAILED");
        // clearDB();
        navigate(`/app`, { replace: true });
        // Authv2.isAuthenticated = activityState.ERROR;
        // Authv2.token = {}
        // window.localStorage.clear();
        // clearAxios()
      }
      // debugger
      // setTimeout(onCheckClientComplete(Authv2.token), 100);
    }
  };
  useEffect(() => {
    resetConnect();
  }, []);
  return (
    <div className="h-screen w-screen flex justify-center items-center">
      <Loader />
      {/* {rtoken}-----{path} */}
    </div>
  );
};
export default AutoConnect;

// http://localhost:3000/portal/connect/eyJhbGciOiJIUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICIzNmJmOWYxZi1hNjQ3LTQ4YjUtOWM1ZS03NTBhMTFlNDZlMTAifQ.eyJleHAiOjE3MjM2MTU2MjUsImlhdCI6MTcyMTAyMzYyNSwianRpIjoiNzc5YzZhYTItYjA5Zi00MzJmLThmNGYtZWZhNDg4MDEzYmY0IiwiaXNzIjoiaHR0cHM6Ly91czMtdGVzdC5uY3NhcHAuY29tL2F1dGgvcmVhbG1zL25jcyIsImF1ZCI6Imh0dHBzOi8vdXMzLXRlc3QubmNzYXBwLmNvbS9hdXRoL3JlYWxtcy9uY3MiLCJzdWIiOiI1MjQ0NGU0ZC00NjAyLTRlN2MtODc4ZC04N2Y2OGJiZWJmNzEiLCJ0eXAiOiJSZWZyZXNoIiwiYXpwIjoibmNzIiwic2Vzc2lvbl9zdGF0ZSI6IjdmNTQyMGYzLTkyZDItNGM0NC1iZGRjLTdkMWQwM2UxMTBiNSIsInNjb3BlIjoiZW1haWwgcHJvZmlsZSIsInNpZCI6IjdmNTQyMGYzLTkyZDItNGM0NC1iZGRjLTdkMWQwM2UxMTBiNSJ9.FwSmyGpIymXj7dbGUFdREvzfa1XxKzUKBUYwv3o5FHg/phoneBridge
// http://localhost:3000/portal/connect/eyJhbGciOiJIUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICIzNmJmOWYxZi1hNjQ3LTQ4YjUtOWM1ZS03NTBhMTFlNDZlMTAifQ.eyJleHAiOjE3MjM2MTc0ODIsImlhdCI6MTcyMTAyNTQ4MiwianRpIjoiOGNhMDVjZDItY2ZiOS00NjlmLWFjODEtYTdkNzgzOTU5M2NkIiwiaXNzIjoiaHR0cHM6Ly91czMtdGVzdC5uY3NhcHAuY29tL2F1dGgvcmVhbG1zL25jcyIsImF1ZCI6Imh0dHBzOi8vdXMzLXRlc3QubmNzYXBwLmNvbS9hdXRoL3JlYWxtcy9uY3MiLCJzdWIiOiI4OWFhNTg2Ni02NDc3LTQxZDItODNmMi0wZjY0MjdiNzUzOWUiLCJ0eXAiOiJSZWZyZXNoIiwiYXpwIjoibmNzIiwic2Vzc2lvbl9zdGF0ZSI6ImQwZWM1ZTY0LTk3MDItNDQ4Ni1hNGRlLTNkNjhlZGU2NmEyYyIsInNjb3BlIjoiZW1haWwgcHJvZmlsZSIsInNpZCI6ImQwZWM1ZTY0LTk3MDItNDQ4Ni1hNGRlLTNkNjhlZGU2NmEyYyJ9.3uSticP7tktxLRWsCURagL9Bgrn-kdkQh1Ofzhi1GfM/phoneBridge
